import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { StockSortParams } from 'src/app/core/services/stock.service';
import { ProductManagementFiltersParams } from 'src/models/Product';

@Component({
  selector: 'app-product-management-table-header',
  templateUrl: './product-management-table-header.component.html',
  styleUrls: ['./product-management-table-header.component.scss']
})
export class ProductManagementTableHeaderComponent implements OnInit {
  @Output() filterValues = new EventEmitter();
  showCheckIcon = {};
  sortDirection: "ASC" | "DESC";
  sortParams: StockSortParams;
  sortColumn = null;
  appliedFilters: ProductManagementFiltersParams = {};
  filterParams: ProductManagementFiltersParams = {};
  form = new FormGroup({
    name: new FormControl(null),
    description: new FormControl(null),
    sku: new FormControl(null),
    minWeight: new FormControl(null),
    maxWeight: new FormControl(null),
    minHeight: new FormControl(null),
    maxHeight: new FormControl(null),
    minWidth: new FormControl(null),
    maxWidth: new FormControl(null),
    minDepth: new FormControl(null),
    maxDepth: new FormControl(null)
  });

  constructor() { }

  ngOnInit(): void {
  }

  sort(orderBy: string, sortBy: "ASC" | "DESC") {
    this.sortParams = null;
    this.showCheckIcon = {};
    this.sortDirection = sortBy;
    this.showCheckIcon[orderBy] = true;
    this.sortParams = { orderBy, sortBy };
  }

  clearFilters(menu: MatMenuTrigger, filter: string) {
    this.sortColumn = this.sortColumn === filter ? null : this.sortColumn;
    this.sortParams = this.sortParams?.orderBy === filter ? null : this.sortParams;
    delete this.appliedFilters?.[filter];
    delete this.showCheckIcon?.[filter];

    switch (filter) {
      case 'name':
        this.form.get('name').reset();
        delete this.filterParams?.['name'];
        break;
      case 'sku':
        this.form.get('sku').reset();
        delete this.filterParams?.['sku'];
        break;
      case 'description':
        this.form.get('description').reset();
        delete this.filterParams?.['description'];
        break;
      case 'weight':
        this.form.get('maxWeight').reset();
        this.form.get('minWeight').reset();
        delete this.filterParams?.['maxWeight'];
        delete this.filterParams?.['minWeight'];
        break;
      case 'width':
        this.form.get('maxWidth').reset();
        this.form.get('minWidth').reset();
        delete this.filterParams?.['minWidth'];
        delete this.filterParams?.['maxWidth'];
        break;
      case 'height':
        this.form.get('minHeight').reset();
        this.form.get('maxHeight').reset();
        delete this.filterParams?.['minHeight'];
        delete this.filterParams?.['maxHeight'];
        break;
      case 'depth':
        this.form.get('minDepth').reset();
        this.form.get('maxDepth').reset();
        delete this.filterParams?.['maxDepth'];
        delete this.filterParams?.['minDepth'];
        break;
    }

    this.filterValues.emit({
      filterParams: this.filterParams,
      sortParams: this.sortParams
    });
    menu.closeMenu();
  }

  applyFilters(menu: MatMenuTrigger) {
    this.filterParams = {
      name: this.form.value.name,
      description: this.form.value.description,
      sku: this.form.value.sku,
      minWeight: this.form.value.minWeight,
      maxWeight: this.form.value.maxWeight,
      minHeight: this.form.value.minHeight,
      maxHeight: this.form.value.maxHeight,
      minWidth: this.form.value.minWidth,
      maxWidth: this.form.value.maxWidth,
      minDepth: this.form.value.minDepth,
      maxDepth: this.form.value.maxDepth,
    };
    this.removeNullKeys(this.filterParams);
    this.sortColumn = this.sortParams?.orderBy;
    this.filterValues.emit({
      filterParams: this.filterParams,
      sortParams: this.sortParams
    });
    menu.closeMenu();
  }

  removeNullKeys(params) {
    Object.keys(params).forEach(key => {
      if (params[key] === null) {
        delete params[key];
      } else {
        this.setAppliedFilters(key);
      }
    });
  }

  setAppliedFilters(name: string) {
    switch (name) {
      case 'maxHeight':
      case 'minHeight':
        this.appliedFilters['height'] = true;
        break;
      case 'minWidth':
      case 'maxWidth':
        this.appliedFilters['width'] = true;
        break;
      case 'minDepth':
      case 'maxDepth':
        this.appliedFilters['depth'] = true;
        break;
      case 'minWeight':
      case 'maxWeight':
        this.appliedFilters['weight'] = true;
        break;
      default:
        this.appliedFilters[name] = true;
        break;
    }
  }

}
